import { Avatar } from 'antd'
import React from 'react'
import { LetterUnreadOutlineIcon, PhoneOutlineIcon } from '../AppIcon'
import { EmptyText } from '../Common/CellText'

const UserCard = props => {
  const { name, role, email, phone, avatar, addon = null, className } =
    props || {}
  return (
    <div
      style={{
        position: 'relative',
        borderRadius: 12,
        background: '#fff',
        padding: '20px 16px',
        textAlign: 'center',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        height: '100%',
      }}
      className={className}>
      {Boolean(addon) && (
        <div
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
          }}>
          {addon}
        </div>
      )}

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Avatar
          onError={() => true}
          size={72}
          src={avatar}
          style={{
            flexShrink: 0,
            backgroundColor: '#60A5FA',
          }}>
          {name?.charAt(0)?.toUpperCase()}
        </Avatar>

        <h3
          title={name?.toLowerCase()}
          style={{
            marginTop: 8,
            marginBottom: 0,
            fontSize: 14,
            fontWeight: 600,
            color: '#000',
            textTransform: 'capitalize',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
            minWidth: 0,
          }}>
          {name?.toLowerCase()}
        </h3>

        <p
          style={{
            marginTop: 4,
            marginBottom: 0,
            fontSize: 12,
            color: '#1D2630',
          }}>
          {role}
        </p>

        <div
          style={{
            marginTop: 16,
            width: '100%',
          }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: 4,
            }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                maxWidth: '100%',
                minWidth: 0,
              }}>
              <LetterUnreadOutlineIcon
                style={{
                  width: 16,
                  height: 16,
                  flexShrink: 0,
                  color: '#006DB2',
                }}
              />
              <span
                title={email || 'Không rõ'}
                style={{
                  fontSize: 14,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}>
                {email ? email : <EmptyText>Không rõ</EmptyText>}
              </span>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                maxWidth: '100%',
                minWidth: 0,
              }}>
              <PhoneOutlineIcon
                style={{
                  width: 16,
                  height: 16,
                  flexShrink: 0,
                  color: '#006DB2',
                }}
              />
              <span
                title={phone || 'Không rõ'}
                style={{
                  fontSize: 14,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}>
                {phone ? phone : <EmptyText>Không rõ</EmptyText>}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserCard
